export default __webpack_public_path__ + "static/photo1-6be613a73ba44da271b7e31ebb7c92d6.png";